export const debounce = (func: any, delay: number) => {
  let timerId: ReturnType<typeof setTimeout>;

  return (...args: any[]) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => func(...args), delay);
  };
};
